import React from "react";
import Title from "../../ui/Title/Title";

import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setActiveTg, setActiveWa } from "../../store/slices/integrationSlice";
import Button from "../../ui/Button/Button";
import styles from "./ScreenHeader.module.scss";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ChevronLeftIcon } from "../../assets/icons/ChevronLeftIcon";
import { setActiveAvito } from "../../store/slices/avitoSlice";
import SaveIcon from "../../assets/icons/SaveIcon";
import "./toast.css";
import { ClipLoader } from "react-spinners";

export default function ScreenHeader({
  title,
  actions = [],
  isEditing = false,
  onSaveUpdatedData,
  onCancelEdit,
  path,
  loading,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleGoBack = () => {
    dispatch(setActiveTg(null));
    dispatch(setActiveWa(false));
    dispatch(setActiveAvito(null));
    navigate(path);
  };

  return (
    <div className={`${styles.container}`}>
      <div
        className={styles.headerContainer}
        onClick={path ? handleGoBack : undefined}
      >
        {path && <ChevronLeftIcon width={20} height={23} fill={"#151515"} />}
        <Title title={title} />
        <ToastContainer position="top-center" />
      </div>

      <div className={styles.action}>
        {!isEditing &&
          actions.map((action, index) => {
            return (
              <Button
                key={index}
                title={action.title}
                leftIcon={action.icon}
                className={action.className}
                titleClassName={action.titleClassName}
                onClick={action.onClick}
              />
            );
          })}
        {isEditing && (
          <Button
            leftIcon={
              loading ? <ClipLoader size={12} color="white" /> : <SaveIcon />
            }
            title="Сохранить"
            className={styles.addButton}
            titleClassName={styles.titleAddButton}
            onClick={onSaveUpdatedData}
          />
        )}
        {isEditing && (
          <Button
            title="Отменить"
            className={styles.delButton}
            titleClassName={styles.titleCancelButton}
            onClick={onCancelEdit}
          />
        )}
      </div>
    </div>
  );
}
